// extracted by mini-css-extract-plugin
export default {"sectionContentInner":"euSKAw5z86NqURobkblw","collapse":"wGSOH7TtNqC8FIEKoZg4"};